import { ShopOrdersProduct } from '@features/halalShop/store/types';
import { HalalShopPageSection } from '@pages/HalalShopPage/types';
import { useMemo } from 'react';
import { useNavigate } from 'react-router-dom';
import { HalalShopProductCard } from '../components/HalalShopProductCard';

export const useGetHalalShopProductCard = (
  data: ShopOrdersProduct[] | undefined,
  pageIndex: string,
) => {
  const navigate = useNavigate();
  return useMemo(() => {
    return (
      data &&
      data.map((item, index) => {
        return (
          <HalalShopProductCard
            key={item.id}
            name={item.name}
            id={item.id}
            image={item.image}
            currency={item.price.currency}
            cost={item.price.value}
            isActive={true}
            onEditClick={() => {
              navigate(
                `${HalalShopPageSection.Catalog}/${item.id}&backLink=${pageIndex}`,
              );
            }}
          />
        );
      })
    );
  }, [data, navigate, pageIndex]);
};
